import ideaImage from '../../../assets/images/instruct-idea.jpg';
import productImage from '../../../assets/images/instruct-product.jpg';
import ceoImage from '../../../assets/images/instruct-ceo.jpg';
import businessImage from '../../../assets/images/instruct-business.jpg';
import infrastructureImage from '../../../assets/images/instruct-infrastructure.jpg';
import customersImage from '../../../assets/images/instruct-customers.jpg';
import brandingImage from '../../../assets/images/instruct-branding.jpg';
import tourImage from '../../../assets/images/instruct-tour.svg';

export const INSTRUCTIONAL_ROUTES = {
    idea: locale => `/${locale}/idea/idea?modal=idea`,
    business: (locale, bmcVisionId) => `/${locale}/bmc_boards/${bmcVisionId}?modal=business`,
    infrastructure: locale => `/${locale}/memberships/affiliation?modal=infrastructure`,
    products: (locale, vpId) => `/${locale}/value_propositions/${vpId}/product?modal=products`,
    startup: (locale, pitchId) => `/${locale}/pitch/${pitchId}?modal=startup`,
    ceo: (locale, currentStartupId) => `/${locale}/igceo/startups/${currentStartupId}?modal=ceo`,
    tour: locale => `/${locale}/tour`,
};

export const SECTION_IMAGE = {
    idea: ideaImage,
    business: businessImage,
    infrastructure: infrastructureImage,
    products: productImage,
    startup: brandingImage,
    customers: customersImage,
    ceo: ceoImage,
    tour: tourImage,
};

export const SECTION_IMAGE_AUTHOR = {
    idea: 'Freepik',
    business: 'Freepik',
    infrastructure: 'rawpixel.com',
    products: 'Freepik',
    startup: 'pikisuperstar',
    customers: 'rawpixel.com',
    ceo: 'Freepik',
    tour: 'Freepik',
};

export const PAGES_PER_SECTION = {
    idea: 2,
    business: 3,
    infrastructure: 2,
    products: 2,
    startup: 1,
    customers: 0,
    ceo: 2,
    tour: 2,
};